import { Component, OnInit, HostListener, Inject } from '@angular/core';

import { Router, NavigationEnd } from '@angular/router';
import { UserRequest } from '../shared/models';
import {AccountService, CategoryService, CookbookService, PopupService, SpinnerService} from '../shared/services';
import { HtmlHelper } from '../shared/shared.module';
import { LandingService } from '../shared/services/landing.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/platform-browser';


@Component({
    selector: 'app-landing',
    templateUrl: './index.html'
})
export class LandingComponent implements OnInit {
    constructor(
        private accountService: AccountService,
        private popupService: PopupService,
        private cookbookService: CookbookService,
        private categoriesService: CategoryService,
        private router: Router,
        private landingService: LandingService,
        public sanitizer: DomSanitizer,
        private spinnerService: SpinnerService,
        @Inject(DOCUMENT) private document: Document
    ) { }

    isLogged: boolean;
    emailConfirmed = false;
    user = new UserRequest();
    redirectToWelcome = true;
    isMobile: boolean;
    windowWidth: number = window.innerWidth;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.windowWidth = event.target.innerWidth;
        this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
    }

    ngOnInit(): void {

        this.getLocation(window.location.pathname);
        this.router.events.subscribe((route: NavigationEnd) => {
            this.getLocation(route.url);
        });
        this.accountService.isAuthenticated().then(result => {
            this.isLogged = (result.isLoggedIn && !result.isAnonymous);
        });

        this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
    }

    getLocation(path: string) {
        if (!path) { return; }
        this.redirectToWelcome = (path.indexOf('/welcome') !== -1);
    }

    callLogoRoute() {
      if (this.isLogged) {
        this.router.navigateByUrl('/main/recipes/planning');
      } else {
        this.redirectToWelcome ? this.router.navigateByUrl('') : this.router.navigateByUrl('/main/recipes/list');
      }
    }

    openLoginDialog() {
        this.user = new UserRequest();
        this.landingService.toggleAuthorizationDialog(false);
        this.landingService.toggleSignupDialog(false);
        this.landingService.toggleLoginDialog(true);
    }

    openSignupDialog() {
        this.user = new UserRequest();
        this.landingService.toggleAuthorizationDialog(false);
        this.landingService.toggleLoginDialog(false);
        this.landingService.toggleSignupDialog(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts